export function trimInputValue(id: string, value: string) {
  if (id === 'Email' || id === 'Password') {
    return value.trim();
  }

  return value;
}
